export const dayToNumber = {
  Sunday: 0,
  Monday: 1,
  Tuesday: 2,
  Wednesday: 3,
  Thursday: 4,
  Friday: 5,
  Saturday: 6,
};
export const numberToDay = {
  0: 'Sunday',
  1: 'Monday',
  2: 'Tuesday',
  3: 'Wednesday',
  4: 'Thursday',
  5: 'Friday',
  6: 'Saturday',
};

export const numberToDayShort = {
  0: 'Sun',
  1: 'Mon',
  2: 'Tue',
  3: 'Wed',
  4: 'Thu',
  5: 'Fri',
  6: 'Sat',
};

export const getAllHours = () => {
  let ret: number[] = [];

  for (let i = 0; i < 24; i++) {
    ret.push(i);
  }

  return ret;
};

export const getAllMins = () => {
  let ret: number[] = [];

  for (let i = 0; i < 60; i++) {
    ret.push(i);
  }

  return ret;
};
